import React from 'react'
import { PayPalScriptProvider } from '@paypal/react-paypal-js'
import PayPalMessaging from './PayPalMessaging'

const options = {
  'client-id': 'AfpMAdELR-HyL-rxVf_QkvwjvLXC0G4-J65nmiLuZPOFqJLrr5onuoXtKxsWpIvFiyD9VO7061oa0hNw',
  components: 'messages'
}

const PayPalContainer = ({ price }) => {
  return (
    <PayPalScriptProvider options={options}>
      <PayPalMessaging price={price} />
    </PayPalScriptProvider>
  )
}

export default PayPalContainer
